import * as actionTypes from './../Global_action.types';
import * as api from './../global_api_services/Role.api';

export const RoleRequest = (roleInputs) => ({
  type: actionTypes.ROLE_CREATE_REQUEST,
  payload: roleInputs,
});
export const RoleSuccess = (role) => ({
  type: actionTypes.ROLE_CREATE_SUCCESS,
  payload: role,
});

export const RoleFailure = (error) => ({
  type: actionTypes.ROLE_CREATE_FAILURE,
  payload: error,
});


export const createRole = (roleInputs) => {
  return async (dispatch) => {
    dispatch(RoleRequest(roleInputs));
    try {
      const response = await api.createRole(roleInputs);
      if (response.status === 200) {
        dispatch(RoleSuccess(response.data.role));
        return { success: true, message: response.data.message };
      } else {
        dispatch(RoleFailure(response.message || 'state input failed'));
        return { success: false, message: response.error };
      }
    } catch (error) {
      dispatch(RoleFailure(error.message || 'An error occurred'));
      return { success: false, message: error.message };
    }
  };
};


export const getRoleRequest = () => ({
  type: actionTypes.ROLE_GET_REQUEST,
});

export const getRoleSuccess = (role) => ({
  type: actionTypes.ROLE_GET_SUCCESS,
  payload: role,
});

export const getRoleFailure = (error) => ({
  type: actionTypes.ROLE_GET_FAILURE,
  payload: error,
});

export const getRole = () => {
    return async (dispatch) => {
      dispatch(getRoleRequest());
      try {
        const role = await api.fetchRole();
        dispatch(getRoleSuccess(role));
        return { success: true, data: role };
      } catch (error) {
        dispatch(getRoleFailure(error));
        return { success: false, message: error };
      }
    };
  };
  export const getCompanyRole = (CompanyID) => {
    return async (dispatch) => {
      dispatch(getRoleRequest());
      try {
        const role = await api.fetchRolecompany(CompanyID);
        dispatch(getRoleSuccess(role));
        return { success: true, data: role };
      } catch (error) {
        dispatch(getRoleFailure(error));
        return { success: false, message: error };
      }
    };
  };

export const updateRoleRequest = (id, stateData) => ({
  type: actionTypes.ROLE_UPDATE_REQUEST,
  payload: { id, stateData },
});

export const updateRoleSuccess = (message) => ({
  type: actionTypes.ROLE_UPDATE_SUCCESS,
  payload: message,
});

export const updateRoleFailure = (error) => ({
  type: actionTypes.ROLE_UPDATE_FAILURE,
  payload: error,
});

export const updateRoleById = (id, stateData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    stateData.updated_by = user.user_name;  // Add the user name to the stateData

    dispatch(updateRoleRequest(id, stateData));
    try {
      const response = await api.updateRole(id, stateData);

      dispatch(updateRoleSuccess(response));
      return { success: true, message: response};
    } catch (error) {
      dispatch(updateRoleFailure(error));
      return { success: false, message: error };
    }
  };
};

export const deleteRoleRequest = (id) => ({
    type: actionTypes.ROLE_DELETE_REQUEST,
    payload: id,
  });

  export const deleteRoleSuccess = (message) => ({
    type: actionTypes.ROLE_DELETE_SUCCESS,
    payload: message,
  });

  export const deleteRoleFailure = (error) => ({
    type: actionTypes.ROLE_DELETE_FAILURE,
    payload: error,
  });

  export const deleteRoleById = (id) => {
    return async (dispatch) => {
      dispatch(deleteRoleRequest(id));
      try {
        const response = await api.deleteRole(id);
        dispatch(deleteRoleSuccess(response.message));
        return { success: true, message: response.message };
      } catch (error) {
        dispatch(deleteRoleFailure(error));
        return { success: false, message: error };
      }
    };
  };
  export const getUserRoleRequest = (id) => ({
    type: actionTypes.GET_USER_ROLE_REQUEST,
    payload: id,
  });

  export const getUserRoleSuccess = (message) => ({
    type: actionTypes.GET_USER_ROLE_SUCCESS,
    payload: message,
  });

  export const getUserRoleFailure = (error) => ({
    type: actionTypes.GET_USER_ROLE_FAILURE,
    payload: error,
  });

  export const getUserRole = () => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    const getUserRole = user.role_name;
    return async (dispatch) => {
      dispatch(getUserRoleRequest(getUserRole));
      try {
        const response = await api.getUserRole(getUserRole);
        dispatch(getUserRoleSuccess(response.message));
        return { success: true, data: response };
      } catch (error) {
        dispatch(getUserRoleFailure(error));
        return { success: false, message: error };
      }
    };
  };
